import { render, staticRenderFns } from "./publish_modal.vue?vue&type=template&id=bd0e963c&lang=pug"
import script from "./publish_modal.vue?vue&type=script&lang=js"
export * from "./publish_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports